import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Button from "@/components/buttons/Button.tsx";
import { IconArrowLeft } from "@/components/icons";

import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

const BackButton = ({ className }: { className?: string }): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const push = () => navigate(ROUTES.STAFF.NAVIGATIONS);

  return (
    <Button
      type={"button"}
      color={"black"}
      size={"medium"}
      icon={<IconArrowLeft className={"stroke-on-primary size-6"} />}
      onClick={push}
      className={cn("w-fit px-5 py-3 lg:hidden", className)}
    >
      {t("navigation.back")}
    </Button>
  );
};

export default BackButton;
